"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var grid_1 = require("./grid");
var Wrapper = (0, styled_components_1.default)(grid_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2px;\n  border-radius: 4px;\n  background-color: ", ";\n"], ["\n  padding: 2px;\n  border-radius: 4px;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grayLight;
});
var Choice = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  appearance: none;\n  border: none;\n  border-radius: 3px;\n  padding: 0.5rem 1.5rem;\n  width: 50%;\n  font-weight: 600;\n  background-color: ", ";\n\n  &:hover {\n    ", "\n  }\n"], ["\n  appearance: none;\n  border: none;\n  border-radius: 3px;\n  padding: 0.5rem 1.5rem;\n  width: 50%;\n  font-weight: 600;\n  background-color: ", ";\n\n  &:hover {\n    ", "\n  }\n"])), function (_a) {
    var active = _a.active, theme = _a.theme;
    return active ? theme.colors.white : 'transparent';
}, function (_a) {
    var active = _a.active;
    return (!active ? 'cursor: pointer;' : '');
});
var Toggle = function (_a) {
    var left = _a.left, right = _a.right, overrideValue = _a.value, onChange = _a.onChange;
    var _b = (0, react_1.useState)(overrideValue || left), internalValue = _b[0], setValue = _b[1];
    var value = overrideValue || internalValue;
    var leftActive = value === left;
    var handleChange = function (newValue) {
        if (newValue === value)
            return;
        setValue(newValue);
        onChange && onChange(newValue);
    };
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(Choice, { name: left, active: leftActive, onClick: function () { return handleChange(left); } }, left),
        react_1.default.createElement(Choice, { name: right, active: !leftActive, onClick: function () { return handleChange(right); } }, right)));
};
exports.default = Toggle;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Toggle.js.map